<template>
  <div class="page-container">
    <div class="page-header">
      <h1 class="page-title">{{ pageTitle }}</h1>
    </div>

    <div class="billing-nav">
      <router-link to="/system/billing/overview" class="nav-card">
        <div class="nav-icon">
          <i class="ri-dashboard-line"></i>
        </div>
        <div class="nav-content">
          <h3>帳單總覽</h3>
          <p>查看所有客戶的帳單狀態分布和關鍵指標</p>
        </div>
        <i class="ri-arrow-right-s-line nav-arrow"></i>
      </router-link>

      <router-link to="/system/billing/payment-records" class="nav-card">
        <div class="nav-icon">
          <i class="ri-file-list-line"></i>
        </div>
        <div class="nav-content">
          <h3>付款記錄</h3>
          <p>查詢和匯出付款記錄，支援多條件篩選</p>
        </div>
        <i class="ri-arrow-right-s-line nav-arrow"></i>
      </router-link>

      <router-link to="/system/billing/reports" class="nav-card">
        <div class="nav-icon">
          <i class="ri-bar-chart-line"></i>
        </div>
        <div class="nav-content">
          <h3>財務報表</h3>
          <p>生成各種財務分析報表，支援匯出功能</p>
        </div>
        <i class="ri-arrow-right-s-line nav-arrow"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import { usePageTitle } from '@/composables/usePageTitle.js';

export default {
  name: 'BillingManagement',
  setup() {
    const { pageTitle } = usePageTitle('財務管理');

    return {
      pageTitle
    };
  }
};
</script>

<style scoped>
.page-container {
  padding: 0;
}

.page-header {
  margin-bottom: 32px;
}

.page-title {
  font-size: 28px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.billing-nav {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.nav-card {
  display: flex;
  align-items: center;
  padding: 24px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  text-decoration: none;
  color: inherit;
  transition: all 0.2s;
  cursor: pointer;
}

.nav-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
  transform: translateY(-2px);
}

.nav-icon {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eff6ff;
  border-radius: 12px;
  margin-right: 16px;
  flex-shrink: 0;
}

.nav-icon i {
  font-size: 28px;
  color: #3b82f6;
}

.nav-content {
  flex: 1;
}

.nav-content h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 8px 0;
}

.nav-content p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.nav-arrow {
  font-size: 24px;
  color: #9ca3af;
  margin-left: 16px;
  flex-shrink: 0;
}

.nav-card:hover .nav-arrow {
  color: #3b82f6;
  transform: translateX(4px);
}
</style>
